import { formatCurrency } from "@angular/common";
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from "@angular/core";
import { AccountMarketplace } from "@front/m19-api-client";
import { AccountMarketplaceService, AuthService } from "@front/m19-services";
import {
  IBadgeComponent,
  IButtonDirective,
  IFormFieldComponent,
  IInputGroupDirective,
  IInputGroupInput,
  IInputGroupSuffixDirective,
  ILabelComponent,
  MODAL_DATA,
  ModalRef,
  ToasterService,
} from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { FormsModule } from "@angular/forms";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CurrencySymbols, Marketplaces } from "@front/m19-models";

@Component({
  templateUrl: "./update-max-bid.popup.component.html",
  imports: [
    TranslocoDirective,
    IBadgeComponent,
    IButtonDirective,
    IFormFieldComponent,
    ILabelComponent,
    IInputGroupDirective,
    IInputGroupInput,
    IInputGroupSuffixDirective,
    FormsModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalUpdateMaxBidComponent implements OnInit {
  private accountMarketplaceService = inject(AccountMarketplaceService);
  private toasterService = inject(ToasterService);
  private authService = inject(AuthService);

  private readonly destroyRef = inject(DestroyRef);

  maxBid!: number;
  currencySymbol!: string;
  locale?: string;

  loading = signal(false);

  private data = inject(MODAL_DATA) as UpdateMaxBidData;
  ref = inject(ModalRef);

  ngOnInit() {
    this.currencySymbol = CurrencySymbols[Marketplaces[this.data.accountMarketplace.marketplace].currency];
    this.maxBid = this.data.accountMarketplace.maxBid!;
    this.authService.user$.subscribe((user) => {
      this.locale = user?.locale;
    });
  }

  updateMaxBid() {
    this.loading.set(true);
    this.accountMarketplaceService
      .updateMaxBid(this.data.accountMarketplace, this.maxBid)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.toasterService.success(
            "Max Bid successfully changed to " +
              formatCurrency(this.maxBid, this.locale!, this.currencySymbol) +
              " on " +
              this.data.accountMarketplace.accountName +
              ".",
            "Max Bid updated",
          );
          this.loading.set(false);
          this.ref.close();
        },
        error: (error) => {
          this.toasterService.error(error, "Max bid update error");
          this.loading.set(false);
        },
      });
  }
}

export interface UpdateMaxBidData {
  accountMarketplace: AccountMarketplace;
}
